var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookReader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3676_15108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -1,
    width: 19,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2742 8.18951C17.551 8.0593 16.8173 7.99567 16.0824 7.99943C15.6601 7.99943 15.2479 7.99943 14.8357 8.07946C14.3225 7.39806 13.6674 6.83499 12.9153 6.42877C13.5614 5.72673 13.92 4.80958 13.9207 3.8577C13.9207 1.72499 12.1832 -0.00390625 10.0398 -0.00390625C7.89646 -0.00390625 6.15891 1.72499 6.15891 3.8577C6.15965 4.80958 6.5183 5.72673 7.16433 6.42877C6.41669 6.8371 5.7627 7.39585 5.24398 8.06946C4.85187 7.99943 4.43964 7.99943 4.01737 7.99943C3.28183 8.00227 2.54812 8.0726 1.82556 8.20951C1.34186 8.29752 0.993093 8.72072 1.00111 9.20993V17.4634C1.00063 17.7609 1.13328 18.0433 1.36306 18.2337C1.59139 18.4253 1.89348 18.5059 2.18751 18.4538C2.78916 18.3234 3.40182 18.2497 4.01737 18.2337C5.96496 18.2316 7.8703 18.7986 9.4969 19.8644L9.62761 19.9144C9.76097 19.972 9.90451 20.0026 10.0499 20.0044C10.1458 20.0032 10.241 19.9863 10.3314 19.9544H10.4018L10.5325 19.9044C12.1746 18.8112 14.1067 18.2296 16.0824 18.2337C16.6967 18.2365 17.3093 18.2968 17.9123 18.4138C18.2063 18.4659 18.5084 18.3852 18.7367 18.1937C18.9665 18.0032 19.0991 17.7209 19.0986 17.4234V9.16992C19.0969 8.68824 18.7504 8.27621 18.2742 8.18951ZM10.0499 1.99693C11.0269 2.06835 11.7829 2.87792 11.7829 3.8527C11.7829 4.82748 11.0269 5.63705 10.0499 5.70847C9.07286 5.63705 8.31683 4.82748 8.31683 3.8527C8.31683 2.87792 9.07286 2.06835 10.0499 1.99693ZM9.04446 17.3333C7.46864 16.6085 5.75339 16.2331 4.01737 16.2329C3.68558 16.2329 3.35379 16.2329 3.01195 16.2829V10.0003C3.85506 9.90641 4.7069 9.92323 5.54561 10.0503H5.6562C6.85426 10.2694 8.00233 10.7033 9.04446 11.3308V17.3333ZM10.0499 9.60009C9.60279 9.34347 9.13931 9.11622 8.6624 8.91981H8.60208C8.27029 8.78976 7.9385 8.6597 7.59666 8.55966C8.29473 8.0068 9.15775 7.70062 10.0499 7.6893C10.9396 7.69491 11.8024 7.99397 12.5031 8.53965C11.6496 8.80479 10.8271 9.16031 10.0499 9.60009ZM17.0878 16.2829C15.0233 16.0765 12.9409 16.4218 11.0553 17.2833V11.2808C12.0993 10.6693 13.2481 10.2555 14.4436 10.0603H14.6446C15.453 9.93503 16.2743 9.91486 17.0878 10.0003V16.2829Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3676_15108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1,
    height: 20,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookReader);
export default __webpack_public_path__ + "static/media/book-reader.8dc69c37ad2fd5c59b2870ae89ef702d.svg";
export { ForwardRef as ReactComponent };